import { getText } from '@/utils/text/text';

export const LIVESTREAM_PAGE_ENTRY_POINT_DEFAULTS = {
    CTA_LABEL: getText({ text: 'components.livestreamPageEntryPoint.ctaLabel' })
};
